import { useEffect, useRef } from "react";

function CompressorSVG({ running, tripped }) {

  const rotorRef = useRef(null);

  // ================= ROTATION =================
  useEffect(() => {

    let animationId;
    let angle = 0;

    const animate = () => {

      const el = rotorRef.current;

      if (!el) return;

      if (running && !tripped) {
        angle += 4; // speed
      }

      el.setAttribute(
        "transform",
        `rotate(${angle} 100 100)`
      );

      animationId = requestAnimationFrame(animate);
    };

    animate();

    return () => cancelAnimationFrame(animationId);

  }, [running, tripped]);

  return (
    <svg width="260" height="260" viewBox="0 0 200 200">

      {/* ================= DEFINITIONS ================= */}
      <defs>
        <radialGradient id="casingGrad">
          <stop offset="10%" stopColor="#2c3e50" />
          <stop offset="90%" stopColor="#0b0f14" />
        </radialGradient>

        <linearGradient id="metal">
          <stop offset="0%" stopColor="#bdc3c7" />
          <stop offset="50%" stopColor="#ecf0f1" />
          <stop offset="100%" stopColor="#7f8c8d" />
        </linearGradient>

        <radialGradient id="glowRunning">
          <stop offset="0%" stopColor="lime" stopOpacity="0.7" />
          <stop offset="100%" stopColor="transparent" />
        </radialGradient>

        <radialGradient id="glowTripped">
          <stop offset="0%" stopColor="red" stopOpacity="0.7" />
          <stop offset="100%" stopColor="transparent" />
        </radialGradient>
      </defs>

      {/* ================= CASING (STATIC) ================= */}
      <circle
        cx="100"
        cy="100"
        r="85"
        fill="url(#casingGrad)"
        stroke="#34495e"
        strokeWidth="4"
      />

      <path
        d="M40,110 C40,40 160,40 160,110 C160,170 40,170 40,110 Z"
        fill="none"
        stroke="#566573"
        strokeWidth="2"
        opacity="0.4"
      />

      {/* ================= SUCTION NOZZLE ================= */}
      <rect x="10" y="92" width="30" height="16" fill="#95a5a6" />

      {/* ================= DISCHARGE NOZZLE ================= */}
      <rect x="160" y="92" width="30" height="16" fill="#95a5a6" />

      {/* ======================================================
          ROTOR GROUP (SHAFT + IMPELLER + COUPLING)
      ====================================================== */}
      <g ref={rotorRef}>

        {/* ================= COUPLING (ROTATES NOW) ================= */}
        <circle
          cx="100"
          cy="30"
          r="10"
          fill="#34495e"
        />

        {/* ================= SHAFT (NOW ROTATES) ================= */}
        <rect
          x="95"
          y="30"
          width="10"
          height="140"
          fill="#7f8c8d"
        />

        {/* ================= IMPELLER ================= */}
        <circle
          cx="100"
          cy="100"
          r="18"
          fill="url(#metal)"
          stroke="#2c3e50"
          strokeWidth="2"
        />

        {[...Array(8)].map((_, i) => (
          <path
            key={i}
            d="M100 100 L120 60 Q105 90 100 100 Z"
            fill="#bdc3c7"
            opacity="0.9"
            transform={`rotate(${i * 45} 100 100)`}
          />
        ))}

        <circle
          cx="100"
          cy="100"
          r="35"
          fill="none"
          stroke="#95a5a6"
          strokeWidth="1"
          opacity="0.4"
        />

        {/* ================= COUPLING (ROTATES NOW) ================= */}
        <circle
          cx="100"
          cy="165"
          r="10"
          fill="#34495e"
        />

      </g>

      {/* ================= STATUS GLOW ================= */}
      {running && !tripped && (
        <circle
          cx="100"
          cy="100"
          r="60"
          fill="url(#glowRunning)"
        />
      )}

      {tripped && (
        <circle
          cx="100"
          cy="100"
          r="60"
          fill="url(#glowTripped)"
        />
      )}

    </svg>
  );
}

export default CompressorSVG;